import React, { useState, useEffect } from "react";
import "../../../styles/trademodals.scss";
import { t } from "../../../../../utils/i18n";

const DisputeInfoModal = ({ isClaimant, onClose }) => {
  return (
    <div
      className="modal-status-cont "
      tabIndex={-1}
      aria-hidden="true"
      id="disputeInfoModal"
      aria-labelledby="disputeInfoModalLabel"
    >
      <div className="modal-status-alert-cont">
        <div>
          <button
            type="button"
            className="close"
            onClick={() => {onClose('disputeInfoModal')}}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <br/>
        </div>
        <div>
          <p className="modal-title" id="disputeInfoModalLabel">
            {t("p2p.dispute_modal.title")}
          </p>
          <div className="trademodal-notice">
            <span>
              {isClaimant &&
                t("p2p.dispute_modal.claimant")}
              {!isClaimant &&
                t("p2p.dispute_modal.other")}
            </span>
          </div>
          <br/>
          <div className="modal-buttons-section">
            <div>
              <button
                type="button"
                className="modal-tradeaction-paidbtn"
                onClick={() => {onClose('disputeInfoModal')}}
              >
                {t("p2p.dispute_modal.ok")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeInfoModal;
